import * as React from 'react';
export const OverflowMenuContext = React.createContext({
    isBelowBreakpoint: false
});
//# sourceMappingURL=OverflowMenuContext.js.map